import React  from 'react'
import styled from 'styled-components';

function TableComponent({ data }) {
    if (data === null) {
      return null;
    }
  
    // Extract the column headers (months)
    const columns = data.Forecast ? Object.keys(data.Forecast[0]) : [];
  
    return (
      <Wrapper>
        <div className="container">
          <div className="graph">
            <table className="cust-table" id="dataGrid">
              <thead>
                <tr>
                  <th> Units\Weeks</th>
                  {columns.map((column) => (
                    <th key={column}>{column}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {Object.keys(data).map((category) => (
                  <tr key={category}>
                    <th>{category}</th>
                    {columns.map((column) => (
                      <td key={column}>{data[category][0][column]}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Wrapper>
    );
  }

export default TableComponent;

const Wrapper = styled.div`
.container{
    display:flex;
    flex-direction:column;
    justify-content: space-around;
}
  .graph{
    overflow:auto;
    width:100%;
  }
  .cust-table{
    width:fit-content;
  }
  
table {
    /* font-family: Quicksand, Arial, sans-serif; */
    border-collapse: collapse;
    width: 100%;
    text-wrap: nowrap;
    overflow-y: scroll;
    overflow-x:auto;
    font-size: 14px;

  }
  
  table td, table th {
    border: 1px solid var(--clr-primary-8);
    padding: 8px;
  }
  
  table tr:nth-child(even){background-color: var(--clr-white);} 
  
  table tr:hover {background-color: #e5eaed}
  
  table th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #0C3C54;
    color: white;
  }
`